<template>
  <q-form ref="form" class="full-width">
    <div class="row q-mb-md">
      <q-tabs v-model="tab">
        <q-tab name="general" label="General" />
        <q-tab
          v-if="formData.id"
          name="userPermissions"
          label="User Permissions"
        />
      </q-tabs>
    </div>
    <div v-if="tab == 'general'" class="row q-pa-md">
      <div v-if="formData.id" class="col-12 q-px-sm q-pb-md">
        <q-btn
          color="secondary"
          unelevated
          text-color="accent"
          no-caps
          :loading="impersonatingUser"
          @click="impersonateUser"
          v-if="currentUserData.role == 'Admin'"
        >
          <q-icon size="xs" name="mdi-account" class="q-mr-sm"></q-icon>
          Impersonate User
        </q-btn>
      </div>
      <div class="col-12 q-pa-sm">
        <assignMember
          :excludeIDList="[]"
          :id="formData.associationsMembers_id"
          :specificMembers="members"
          :dataLoading="membersLoading"
          @changed="updateMember"
        />
      </div>
      <div class="col-12 q-px-sm q-pt-sm">
        <q-input
          :readonly="formData.id && forAssociation"
          v-model="formData.email"
          v-bind="siteCFG.fields.general"
          label="Email Address"
          :rules="[
            (v) => !!v || 'Email is required',
            (v) => /.+@.+/.test(v) || 'Email must be valid',
          ]"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          :readonly="formData.id && forAssociation"
          v-model="formData.name"
          v-bind="siteCFG.fields.general"
          label="Name"
          :rules="[(v) => !!v || 'Name is required']"
          hide-bottom-space
        ></q-input>
      </div>
      <div v-if="!formData.id" class="col-12 col-md-6 q-px-sm q-pt-md">
        <q-select
          label="Type"
          v-model="formData.type"
          v-bind="siteCFG.fields.general"
          :options="typeOptions"
          option-label="label"
          option-value="value"
          map-options
          emit-value
          :readonly="forAssociation"
        >
        </q-select>
      </div>
      <div
        v-if="formData.type && !formData.id"
        class="col-12 col-md-6 q-px-sm q-pt-md"
      >
        <q-select
          label="Role"
          v-model="formData.role"
          v-bind="siteCFG.fields.general"
          :options="roleOptions[formData.type]"
          option-label="label"
          option-value="value"
          map-options
          emit-value
        >
        </q-select>
      </div>
      <div
        v-if="formData.type == 'Association' && !forAssociation"
        class="col-12 q-px-sm q-pt-md"
      >
        <assignAssociation
          :id="formData.ref_id"
          @changed="(val) => (formData.ref_id = val)"
        >
        </assignAssociation>
      </div>
      <q-checkbox
        v-if="false"
        class="q-pt-sm"
        :true-value="1"
        :false-value="0"
        dense
        indeterminate-value="no-value"
        label="Training Site Email"
        v-model="formData.trainingSiteInvite"
      >
      </q-checkbox>
      <div class="col-12 q-px-sm q-pt-md">
        <q-checkbox
          v-if="formData.role == 'Official'"
          class="q-pt-sm"
          :true-value="1"
          :false-value="0"
          dense
          indeterminate-value="no-value"
          label="Persistent Login"
          v-model="formData.persistentLogin"
        >
        </q-checkbox>
      </div>

      <div
        class="col-12 col-md-6 q-px-sm q-pt-md"
        v-if="
          formData.persistentLogin &&
          formData.role == 'Official' &&
          !formData.id
        "
      >
        <q-input
          v-model="formData.username"
          v-bind="siteCFG.fields.general"
          label="Username"
          :rules="[(v) => !!v || 'Username is required']"
          hide-bottom-space
        ></q-input>
      </div>
      <div
        class="col-12 col-md-6 q-px-sm q-pt-md"
        v-if="
          formData.persistentLogin &&
          formData.role == 'Official' &&
          !formData.id
        "
      >
        <q-input
          v-model="formData.password"
          v-bind="siteCFG.fields.general"
          label="Password"
          :rules="[(v) => !!v || 'Password is required']"
          type="password"
          hide-bottom-space
        ></q-input>
      </div>
      <!-- <div class="col-12 col-md-6 q-px-sm">
        <q-select
          v-bind="siteCFG.fields.general"
          label="Role"
          v-model="formData.role"
          :options="forAssociation ? associationUserRoles : userRoles"
        >
        </q-select>
      </div> -->
    </div>
    <div v-if="tab == 'userPermissions'" class="row q-px-md">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          User Permissions
          <q-btn
            v-if="
              !addUserPermission &&
              !editUserPermission &&
              $route.name != 'supportTeamView'
            "
            class="q-ml-md"
            color="primary"
            text-color="white"
            no-caps
            @click="addUserPermission = true"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>

          <!-- <q-btn
            v-if="!addUserPermission && !editUserPermission"
            class="q-ml-md"
            color="secondary"
            text-color="accent"
            unelevated
            no-caps
            @click="autoGenerateUserPermissionOrder"
          >
            <q-icon
              name="mdi-refresh-auto"
              color="accent"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Auto Order
          </q-btn> -->

          <q-btn
            v-if="addUserPermission"
            class="float-right"
            flat
            @click="addUserPermission = false"
          >
            <q-icon name="mdi-close"></q-icon>
          </q-btn>

          <q-btn
            v-if="editUserPermission"
            class="float-right"
            flat
            @click="$router.push($route.path.split('/permission')[0])"
          >
            <q-icon name="mdi-close"></q-icon>
          </q-btn>
          <q-input
            v-if="!addUserPermission && !editUserPermission"
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="userPermissionsSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div
        v-if="!addUserPermission && !editUserPermission"
        class="col-12"
        style="height: 300px"
      >
        <datatable
          :filter="userPermissionsSearch"
          :flat="true"
          :data="permissions"
          :columns="userPermissionsColumns"
          @rowDoubleClick="userPermissionsDoubleClick"
        >
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="removingUserPermissionID == data.props.row.id"
                @click="removeUserPermission(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-trash-can-outline"></q-icon>
                <q-tooltip>Remove User Permission</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
      <div v-if="addUserPermission" class="col-12">
        <userPermissionsForm
          ref="addUserPermissionForm"
          :forAssociation="forAssociation"
          @close="addUserPermission = false"
          @loadingStateChanged="(state) => (addUserPermissionLoading = state)"
        />
      </div>

      <div v-if="addUserPermission" class="col-12">
        <q-btn
          class="float-right"
          color="primary"
          text-color="white"
          no-caps
          :loading="addUserPermissionLoading"
          @click="submitUserPermissionToAdd"
        >
          <q-icon
            name="mdi-plus-circle"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Add User Permission
        </q-btn>
      </div>
      <div v-if="editUserPermission" class="col-12">
        <userPermissionsForm
          ref="editUserPermissionForm"
          :id="$route.params.userPermissions_id"
          @close="$router.push(`/system/users/${data.id}`)"
          @loadingStateChanged="(state) => (editUserPermissionLoading = state)"
        />
      </div>
      <div v-if="editUserPermission" class="col-12">
        <q-btn
          class="float-right"
          color="primary"
          text-color="white"
          no-caps
          :loading="editUserPermissionLoading"
          @click="saveUserPermission"
        >
          <q-icon
            name="mdi-content-save"
            color="white"
            class="q-mr-sm"
            size="xs"
          ></q-icon>
          Save User Permission
        </q-btn>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import assignMember from "@/components/users/assignMember.vue";
  import assignAssociation from "@/components/associations/assignAssociation.vue";
  import datatable from "@/components/datatable/datatable.vue";
  import userPermissionsForm from "@/components/users/userPermissionsForm.vue";

  export default {
    components: {
      assignMember,
      assignAssociation,
      datatable,
      userPermissionsForm,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        userRoles: "settings/userRoles",
        associationUserRoles: "settings/associationUserRoles",
        siteCFG: "settings/siteCFG",
        data: "users/current",
        dataLoading: "users/currentLoading",
        permissions: "users/permissions",
        permissionsLoading: "users/permissionsLoading",
        members: "associations/membersAll",
        membersLoading: "associations/membersAllLoading",
        typeOptions: "settings/userPermissionTypeOptions",
        roleOptions: "settings/userPermissionRoleOptions",
      }),
    },
    props: {
      id: {
        default: null,
      },
      forAssociation: {
        default: false,
        type: Boolean,
      },
    },
    watch: {
      id: function () {
        this.init();
      },
      data: function () {
        this.init();
      },
      $route: function () {
        this.handleRoute();
      },
    },
    data: () => ({
      // Extra Data
      formData: {
        name: null,
        email: null,
        persistentLogin: 1,
      },

      tab: "general",

      impersonatingUser: false,

      // User Permissions
      userPermissionsColumns: [
        {
          name: "type",
          label: "Type",
          align: "left",
          field: "type",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "role",
          label: "Role",
          align: "left",
          field: "role",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "reference",
          label: "Reference",
          align: "left",
          field: "reference",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "actions",
          label: "",
          align: "left",
          field: "actions",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
      ],
      addUserPermission: false,
      addUserPermissionLoading: false,
      userPermissionsSearch: "",
      removingUserPermissionID: null,
      duplicatingUserPermissionID: null,
      editUserPermission: false,
      editUserPermissionLoading: false,
      userPermissionsList: [],
    }),
    beforeCreate() {},
    mounted() {
      this.init();
      this.handleRoute();
      this.$store.dispatch("users/loadByID", this.id);
      this.$store.dispatch("users/loadPermissionsForUser", this.id);
    },
    methods: {
      init() {
        if (this.data != null && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {
            name: null,
            email: null,
            type: this.forAssociation ? "Association" : null,
            ref_id: this.forAssociation ? this.$route.params.id : null,
            persistentLogin: 1,
          };
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$refs.form.validate().then((result) => {
            if (result) {
              this.$store
                .dispatch("users/newUser", this.formData)
                .then((result) => {
                  this.$emit("loadingStateChanged", false);
                  if (result.Result == "Success") {
                    this.$emit("close", true);
                    this.formData = {};
                    this.$q.notify({
                      position: "top-right",
                      type: "positive",
                      message: result.Response.Message,
                    });
                  } else {
                    this.$q.notify({
                      position: "top-right",
                      type: "negative",
                      message: result.Response.Message,
                    });
                  }
                });
            } else {
              this.$emit("loadingStateChanged", false);
            }
          });
        }, 200);
      },
      save() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$store.dispatch("users/saveUser", this.formData).then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "User has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
        });
      },
      resetTemporaryPassword() {
        this.$q.notify({
          message:
            "Resetting a Temporary password will delete the users current password.",
          color: "warning",
          position: "center",
          timeout: 0,
          actions: [
            {
              label: "Reset Password",
              color: "red",
              handler: () => {
                this.$store.dispatch("users/resetUserTempPassword", {
                  id: this.formData.id,
                  username: this.formData.username,
                });
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message:
                    "The user has been emailed their new Temporary password",
                });
              },
            },
          ],
        });
      },
      impersonateUser() {
        this.impersonatingUser = true;
        this.$store
          .dispatch("auth/impersonate", { id: this.formData.id })
          .then((result) => {
            this.impersonatingUser = false;
            this.$router.push("/");
          });
      },
      updateMember(id) {
        this.formData.associationsMembers_id = id;
        let member = this.members.find((m) => m.id == id);
        this.formData.email = member.emailAddress;
        this.formData.name = `${member.firstName} ${member.lastName}`;
      },
      addUserAssociation(type, ref_id, dispatch) {
        this.$emit("loadingStateChanged", true);

        this.formData.type = type;
        this.formData.ref_id = ref_id;

        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("users/newUser", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                  this.$store.dispatch(dispatch, ref_id);
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      },
      handleRoute() {
        if (this.$route.params.userPermissions_id) {
          this.editUserPermission = true;
        } else {
          this.editUserPermission = false;
        }
      },

      // User Permissions
      userPermissionsDoubleClick(row) {
        this.$router.push(`${this.data.id}/permissions/${row.id}`);
      },
      removeUserPermission(id) {
        this.removingUserPermissionID = id;
        this.$store
          .dispatch("users/userRemovePermission", {
            id: id,
          })
          .then((result) => {
            this.$store.dispatch("users/loadPermissionsForUser", this.id);
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },

      submitUserPermissionToAdd() {
        this.$refs.addUserPermissionForm.create(this.data.id);
      },
      saveUserPermission() {
        this.$refs.editUserPermissionForm.save();
      },
    },
  };
</script>
